import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAppState = state => ({
  type: actionTypes.SET_APP_STATE,
  payload: state
})
